// @flow
import { connect } from 'react-redux';
import { getAuthUser } from '../auth/authState';

// Показывает детей всем, кроме управляющего. Управляющий видит админку целиком,
// но без кнопок создания/правки/удаления — менять данные ему нельзя, это же
// подтверждает бэкенд отказом на любую мутацию.
function CanEdit({ user, children }) {
  return user && user.isManager ? null : children;
}

export default connect(
  (state) => ({ user: getAuthUser(state) }),
)(CanEdit);
